import MasterDataProductEditPage from "@/features/master-data/pages/MasterDataProductEdit";

const MasterDataProductEdit = () => {
  return <MasterDataProductEditPage />;
};

export default MasterDataProductEdit;
